// ЕДИНЫЙ СПРАВОЧНИК СТАТУСА ЗАДАЧИ — по образцу `lib/task-priority.ts`.
//
// ЗАЧЕМ. Подписи и цвета статуса были объявлены заново в четырёх местах: на
// доске задач их было ТРИ подряд в одном файле (`STAGE_COLOR`, `STATUS_META`,
// `STAGES`), плюс свой словарь в кабинете и свой в профиле сотрудника. Они уже
// разошлись: `review` на доске и в кабинете — «Согласование», а в профиле —
// «На проверке»; `new` на доске серый, в профиле фиолетовый. Один и тот же
// статус назывался по-разному на соседних экранах.
//
// Правило портала: похожие элементы меняются из ОДНОГО места.

import type { TeamTaskStatus } from "./types";

export type StageMeta = { key: TeamTaskStatus; label: string; color: string };

/** ⚠️ ПОРЯДОК — жизненный цикл слева направо, завершённое последним (образец
 *  photo_2026-08-25_22-44-28: «Готово» — крайняя правая колонка). На этом
 *  порядке стоят колонки доски, так что менять его — менять доску. */
export const TASK_STAGES: StageMeta[] = [
  { key: "backlog", label: "Бэклог", color: "#94a3b8" },
  { key: "new", label: "Новые", color: "#64748b" },
  { key: "in_progress", label: "В работе", color: "#f59e0b" },
  { key: "review", label: "Согласование", color: "#8b5cf6" },
  { key: "done", label: "Готово", color: "#10b981" },
];

/** Подпись ОДНОЙ задачи (не колонки): «Новая», а не «Новые». */
const ЕДИНСТВЕННОЕ: Partial<Record<TeamTaskStatus, string>> = { new: "Новая" };

const ПО_КЛЮЧУ = new Map(TASK_STAGES.map((s) => [s.key, s]));

/** Метаданные статуса. Незнакомое значение из старых данных читается серым и
 *  своим же ключом, а не роняет экран. */
export function stage(value: string | null | undefined): StageMeta {
  return ПО_КЛЮЧУ.get((value ?? "") as TeamTaskStatus)
    ?? { key: (value ?? "") as TeamTaskStatus, label: String(value ?? "—"), color: "#94a3b8" };
}

export const stageColor = (v: string | null | undefined) => stage(v).color;
/** Подпись колонки: «Новые». */
export const stageLabel = (v: string | null | undefined) => stage(v).label;
/** Подпись одной задачи: «Новая». */
export const stageLabelOne = (v: string | null | undefined) => ЕДИНСТВЕННОЕ[stage(v).key] ?? stage(v).label;
/** Заливка плашки статуса — та же доля, что у приоритета (prioFill). */
export const stageFill = (v: string | null | undefined) =>
  `color-mix(in srgb, ${stageColor(v)} 16%, transparent)`;
